import { jsx as d } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import { BaseIcon as x } from "../BaseIcon/index.js";
const w = a(
  ({ m: o, mb: r, ml: i, mr: m, mt: t, icon: f, id: p, size: c, color: e, __inverted: n }, s) => /* @__PURE__ */ d(
    x,
    {
      ref: s,
      m: o,
      mb: r,
      ml: i,
      mr: m,
      mt: t,
      icon: f,
      id: p,
      size: c,
      __inverted: n,
      color: e,
      description: void 0
    }
  )
);
export {
  w as Icon
};
